import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { PartnerTokenResponse } from 'interfaces/partner-token'

export default function useGetPartnerToken(orgId: string) {
  return useQuery<PartnerTokenResponse, Error>(
    ['partnerToken', orgId],
    async () => {
      const response = await fetch(
        `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/partner_integrations`,
        {
          method: API_METHODS.GET,
          headers: apiHeaders(store.getState()),
        }
      )

      const responseText = await response.text()

      if (!response.ok) {
        if (response.status === 404) {
          return { data: [] }
        }
        throw new Error('Failed to fetch partner token')
      }

      try {
        const json = JSON.parse(responseText)
        // Handle the nested response structure
        return {
          data: json.data?.partner_integrations || [],
        }
      } catch (error) {
        throw new Error('Invalid response format')
      }
    },
    {
      enabled: !!orgId,
    }
  )
}
